import { Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'nl2br',
})
export class Nl2BrPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(value: string | null | undefined, sanitizeBeforehand?: boolean): string | SafeHtml {
    if (typeof value !== 'string') {
      return value ?? '';
    }
    const textParsed = value.replace(/(?:\r\n|\r|\n)/g, '<br />');
    if (sanitizeBeforehand) {
      return this.sanitizer.sanitize(SecurityContext.HTML, textParsed) || '';
    }
    return textParsed;
  }
}
